import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { PiMagnifyingGlassLight } from "react-icons/pi";
import './style/shopinfodec.css'
import './style/rating.css'
import { ShopRating } from './ShopRating';


const ShopInfoDec = ({ product }) => {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className='mt-10'>
            <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                            <Tab label="DESCRIPTION" value="1" />
                            <Tab label=" ADDITIONAL INFORMATION" value="2" />
                            <Tab label=" REVIEWS" value="3" />
                            <Tab label=" Q & A" value="4" />
                        </TabList>
                    </Box>

                    <Box>
                        <TabPanel value="1">
                            <span className='text-gray-800 tracking-wider '>{product[0]?.desc}</span>
                        </TabPanel>
                        <TabPanel value="2">
                            <div>
                                <table>
                                    <tbody>
                                        <tr>
                                            <th className=' text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2'>Weight</th>
                                            <td className='text-gray-500 ms-5'>1 kg</td>
                                        </tr>
                                        <tr className='py-5'>
                                            <th className=' text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2'>Dimensions</th>
                                            <td className='text-gray-500'>10 × 11 × 22 cm</td>
                                        </tr>
                                        <tr >
                                            <th className=' text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2'>Color</th>
                                            <td>{product[0]?.jwelleryColour} (Colour was customization)</td>
                                        </tr>
                                        <tr className='my-2'>
                                            <th className=' text-base font-semibold tracking-wide ms-2 text-gray-600 text-start me-2'>Sizes</th>
                                            <td>10K, 18K, 22K, 24K</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </TabPanel>
                        <TabPanel value="3">
                           <ShopRating product={product}/>
                        </TabPanel>

                        <TabPanel value="4">
                            <p className='text-3xl'>Q & A</p>
                            <div className='flex mt-5'>
                                <p className='border px-3 py-3 flex'><input type="text" placeholder=' Search Answers' /></p>
                                <span className='rounded-none ms-4 py-4 px-10 bg-black text-white'>Ask a question</span>
                            </div>
                        </TabPanel>
                    </Box>
                </TabContext>
            </Box>
        </div>
    )
}

export default ShopInfoDec
